import { apiClient } from '../config/api'
import type { AssetPeripheral, PeripheralCapability } from './assetPeripheralService'

export interface CockpitCaptor {
  id: string
  label: string
  value: number | string | null
  unit?: string | null
}

export interface CockpitBle {
  bleId?: string
  model?: string
  temperature?: number | null
  humidity?: number | null
  battery?: number | null
  lastSeen?: string | null
}

export interface CockpitTelemetry {
  source: string
  online?: boolean | null
  model?: string | null
  lastSeen?: string | null
  latitude?: number | null
  longitude?: number | null
  speedKmh?: number | null
  heading?: number | null
  externalVoltageV?: number | null
  batteryLevel?: number | null
  ignition?: boolean | null
  movement?: boolean | null
  odometerM?: number | null
  captors?: CockpitCaptor[]
  gatewayError?: string | null
  note?: string | null
}

export interface CockpitDevice {
  peripheral: AssetPeripheral
  telemetry: CockpitTelemetry | null
  ble: CockpitBle[]
  deepLinkWindow?: string | null
}

export interface AssetCockpitResponse {
  assetId: string
  assetType: 'asset' | 'container' | null
  vehicle: {
    source: 'ASSET' | 'CONTAINER'
    id: number | string
    code?: string | null
    name?: string | null
    plate?: string | null
    brand?: string | null
    model?: string | null
    type?: string | null
    customerId?: number | null
    customerName?: string | null
  } | null
  deviceCount: number
  devices: CockpitDevice[]
  generatedAt: string
}

const enc = encodeURIComponent

export const assetCockpitService = {
  async getCockpit(assetId: string | number): Promise<AssetCockpitResponse> {
    const { data } = await apiClient.get(`/assets/${enc(String(assetId))}/cockpit`)
    return data as AssetCockpitResponse
  },
}

export function capabilityLabel(c: PeripheralCapability | string | null | undefined): string {
  switch (c) {
    case 'SMART_LOCK': return 'Smart Lock'
    case 'GPS_TRACKER': return 'GPS Tracker'
    case 'AI_DASHCAM': return 'AI Dashcam'
    case 'OBD': return 'OBD / Fuel'
    case 'TAG': return 'BLE Tag'
    default: return 'Device'
  }
}
